import React from "react";

const InstructionBadge = ({ icon: Icon, children }) => (
  <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-[7px] tw-border tw-border-solid tw-border-dis-border-strong tw-bg-white tw-px-2.5 tw-py-1 tw-align-baseline tw-text-[14px] tw-font-bold tw-leading-tight tw-text-dis-navy">
    {Icon && <Icon className="tw-h-3.5 tw-w-3.5 tw-shrink-0" aria-hidden="true" />}
    {children}
  </span>
);

export default InstructionBadge;
